import "core-js/modules/es.number.constructor.js";
// 引入组件
import tinymce from 'tinymce';
import 'tinymce/themes/silver';
import Editor from '@tinymce/tinymce-vue';
import 'tinymce/icons/default/icons';

// 引入富文本编辑器主题的js和css
import 'tinymce/themes/silver/theme.min';
import 'tinymce/skins/ui/oxide/skin.min.css';
// 扩展插件
import 'tinymce/plugins/image';
import 'tinymce/plugins/link';
import 'tinymce/plugins/code';
import 'tinymce/plugins/table';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/wordcount'; // 字数统计插件
import 'tinymce/plugins/media'; // 插入视频插件
import 'tinymce/plugins/template'; // 模板插件
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/contextmenu';
import 'tinymce/plugins/textcolor';
import 'tinymce/plugins/print';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/directionality';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/visualchars';
import 'tinymce/plugins/codesample';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/hr';
import 'tinymce/plugins/pagebreak';
import 'tinymce/plugins/nonbreaking';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/imagetools';
import 'tinymce/plugins/textpattern';
import 'tinymce/plugins/help';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/autosave';
import { upload } from "@/services/common";
export default {
  name: 'TinymceEditor',
  components: {
    Editor: Editor
  },
  props: {
    height: {
      type: Number,
      default: 600
    },
    id: {
      type: String,
      default: 'tinymceEditor'
    },
    value: {
      type: String,
      default: ''
    },
    plugins: {
      type: [String, Array],
      default: 'code print preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media template code codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount imagetools textpattern help emoticons autosave paste contextmenu textcolor'
      // defualt: 'print preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media template code codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount imagetools textpattern help emoticons autosave autoresize paste contextmenu textcolor'
    },
    // toolbar: {
    // type: [String, Array],
    // default:'code undo redo | cut copy paste  pastetext| forecolor backcolor bold italic underline strikethrough link unlink anchor | alignleft aligncenter alignright alignjustify  outdent indent  | styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | lineheight'
    //             default:'code undo redo | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link unlink anchor | alignleft aligncenter alignright alignjustify outdent indent | \
    // styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
    // table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | lineheight'
    // },
    toolbar: {
      type: [String, Array],
      default: function _default() {
        return ['code undo redo | cut copy paste  pastetext| forecolor backcolor bold italic underline strikethrough link unlink anchor | alignleft aligncenter alignright alignjustify  outdent indent | bullist numlist | fullscreen | lineheight | styleselect formatselect fontselect fontsizeselect | blockquote subscript superscript removeformat | table image media charmap emoticons hr pagebreak insertdatetime print preview'];
      }
    }
  },
  data: function data() {
    var _this = this;
    return {
      editorInit: {
        forced_root_block: false,
        convert_urls: false,
        relative_urls: false,
        language_url: "/tinymce/langs/ja.js",
        language: 'ja',
        skin_url: "/tinymce/skins/ui/oxide",
        content_css: "/tinymce/skins/content/default/content.css",
        height: this.height,
        content_style: '* { padding:0; margin:0; } img {max-width:100% !important; height:auto !important }',
        plugin_preview_width: 375,
        // 预览宽度
        plugin_preview_height: 668,
        lineheight_val: "1 1.1 1.2 1.3 1.35 1.4 1.5 1.55 1.6 1.75 1.8 1.9 1.95 2 2.1 2.2 2.3 2.4 2.5 2.6 2.7 2.8 3 3.1 3.2 3.3 3.4 4 5",
        fontsize_formats: "12px 14px 16px 18px 24px 36px 48px 56px 72px",
        font_formats: "微软雅黑='微软雅黑';宋体='宋体';黑体='黑体';仿宋='仿宋';楷体='楷体';隶书='隶书';幼圆='幼圆';Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings",
        plugins: this.plugins,
        powerpaste_word_import: 'merge',
        toolbar: this.toolbar,
        paste_data_images: true,
        statusbar: true,
        // 底部的状态栏
        menubar: false,
        // 最上方的菜单
        branding: false,
        // 水印“Powered by TinyMCE”
        // images_upload_url: process.env.VUE_APP_API_BASE_URL + "/common/upload",//上传URl
        images_upload_handler: function images_upload_handler(blobInfo, success, failure) {
          _this.$emit('handleImgUpload', blobInfo, success, failure);
        }

        // 此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
        // 如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
        /* images_upload_handler: (blobInfo, success, failure) => {
        	let formData = new FormData();
        	formData.append('file', blobInfo.blob(), blobInfo.filename());
        	upload(formData).then((res)=>{
        		if(res.code == 200){
        			success(res.data.urlpath+res.data.uploadfilepath);
        		}else{
        			failure('HTTP Error: ' + res.message);
        		}
        	}); */
      },
      editorId: this.id,
      newValue: ''
    };
  },
  watch: {
    newValue: function newValue(_newValue) {
      this.$emit('input', _newValue);
    }
  },
  mounted: function mounted() {
    tinymce.init({});
    this.newValue = this.editorValue;
  },
  computed: {
    editorValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.newValue = val;
      }
    }
  },
  methods: {
    onClick: function onClick(e) {
      this.$emit('onClick', e, tinymce);
    },
    // https://github.com/tinymce/tinymce-vue => All available events
    clear: function clear() {
      this.editorValue = '';
    }
  }
};